import LabRepository from "./LabRepository";

const resource = "/instrument-instance-schedule";

export default {
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  update(id, payload) {
    return LabRepository.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return LabRepository.delete(`${resource}/${id}`);
  },
  deleteBatch(payload) {
    return LabRepository.delete(resource, { params: { payload } });
  }
};
